import { UserService } from './../../../base-services/user.service';
import { ChangeDetectorRef, Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { MakeProvider } from "../../abstract-custom-control";
import { BaseNumberInput } from "./base-number-input";
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'yt-number-input-v2',
    templateUrl: './number-input.component.html',
    providers: [ MakeProvider(NumberInputComponentV2) ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NumberInputComponentV2 extends BaseNumberInput {
    constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected userService: UserService,
        protected decimalPipe: DecimalPipe
    ){
        super(changeDetectorRef, userService, decimalPipe);
    }

    private initValue: number = 0;
@Input() selectOnEntry: boolean = false;

    ngOnInit(){
        super.ngOnInit();
        //this.value = 0;
        //this.onBlur();
    }

    ngAfterViewInit(){
        //this.value = 0;
        //this.onBlur();

        let __this = this;
        setTimeout(() => {
            if(this.selectOnEntry) {
                this.inputControl.nativeElement.setSelectionRange(0, this.inputControl.nativeElement.value.length);
            }
        }, 100);
    }

    onKeyDown(event){
        if(!this.isAllowed(event.keyCode, event.key))
            this.prevent(event);

        if(event.key == '-'){
            this.value = 0 - this.value;
            this.prevent(event);
            this.displayValue = this.decimalPipe.transform(this.value, this.FormatString, this.userService.GetLocaleString());
            this.changeDetectorRef.markForCheck();
        }

        if(event.ctrlKey && event.key == 'a'){
            this.inputControl.nativeElement.selectionStart = 0;
            this.inputControl.nativeElement.selectionEnd = this.inputControl.nativeElement.value.length;
        }
        
        if(event.keyCode == 27){
            this.value = this.oldValue;
            this.onBlur();
        }
    }

    onInput(event){
        //super.onInput(event);

        let value = event.target.value;
        this.value = parseFloat(value.replace(new RegExp('\\' + this.ts, 'g'), '').replace(this.ds, '.'));
        //this.onBlur();
    }

    isAllowed(keyCode: number, key: string = ''){
        if (this.displayValue){
            let selection = this.displayValue.toString().substr(this.inputControl.nativeElement.selectionStart, this.inputControl.nativeElement.selectionEnd - this.inputControl.nativeElement.selectionStart);
            return super.isAllowed(keyCode) || (keyCode == 110 && key == this.ds && !this.hasDs(selection || '') && this.nofd > 0) || (keyCode == 109 //&& this.displayValue.indexOf('-') == -1
            );     
        }
        else
            return true;
       }

    onBlur(){
        this.setValues();
        this.OnBlur.emit(this.value);
    }

    private setValues(){
        if(this.value == null || isNaN(this.value))
            this.value = this.initValue;
        this.displayValue = this.decimalPipe.transform(this.value, this.FormatString, this.userService.GetLocaleString());
        this.value = parseFloat(this.displayValue.replace(new RegExp('\\' + this.ts, 'g'), '').replace(this.ds, '.'));
        this.changeDetectorRef.markForCheck();
    }

    writeValue(value){
        super.writeValue(value);
        //if(value == null)
            //this.value = this.initValue;
        this.oldValue = value;
        //this.onBlur();
        this.setValues();
        this.OnChange.emit(this.value);
    }
}